import { Component } from '@angular/core';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'primetest';
  items: MenuItem[];
  popmenuItems: MenuItem[];
  profileMenu : MenuItem[];

  status: boolean = false;

  clickEvent(){
    this.status = !this.status;       
  }

  ngOnInit() {
    /*Main side menu items*/
      this.items = [
          {
          label: 'Master Data',
          icon:'pi pi-fw pi-book',
          items: [
              {
                  label: 'Companies',
                  routerLink:'companies',
              },
              {
                  label: 'Departments',
                  routerLink:'departments'
              },
              {
                label: 'Employees',
                routerLink:'employees'
              },
              {
                label: 'Job Types',
                routerLink:'jobTypes'
              },
              {
                label: 'Job Categores',
                routerLink:'jobCategories'
              },
              {
                label: 'Budget',
                routerLink:'budget'
              },
              {
                label: 'Vehicles',
                routerLink:'vehicles'
              }
          ]
          },
          {
            label: 'Templates',
            icon:'pi pi-fw pi-th-large',
            items: [
                {
                    label: 'All Templates',
                    routerLink:'allTemplates'
                },
                {
                    label: 'Create Template',
                    routerLink:'createTemplate'
                },
            ]
          },
          {
            label: 'Jobs',
            icon:'pi pi-fw pi-id-card',
            items: [
                {
                    label: 'All Jobs Requests',
                    routerLink:'allJobs'
                },
                {
                  label: 'My Job Requests',
                  routerLink:'myJobRequests'
                },
                {
                  label: 'Create Job Request',
                  routerLink:'createJobRequest'
                },
                {
                  label: 'All Job Chain',
                  routerLink:'allJobChains'
                },
                {
                  label: 'Create Job Chain',
                  routerLink:'createJobChain'
                },
            ]
          },
          {
            label: 'Budget',
            icon:'pi pi-fw pi-dollar',
            items: [
                {
                    label: 'All Budget Requests',
                    routerLink:'allBudgetRequests'
                },
                {
                  label: 'My Budget Requests',
                  routerLink:'myBudgetRequets'
                },
                {
                  label: 'Budget Status',
                  routerLink:'budgetStatus'
                },
                {
                  label: 'Review Requests',
                  routerLink:'reviewBudgetRequests'
                },
                {
                  label: 'Budget Allocations',
                  routerLink:'budgetAllocations'
                }
            ]
          },
          {
            label: 'Reports',
            icon:'pi pi-fw pi-file',
            items: [
                {
                    label: 'Budget Consumption',
                    routerLink:'budgetConsumptionReport'
                },
                {
                  label: 'Job Chain Cycle',
                  routerLink:'jobChainCycleReport'
                }
            ]
          },
          {
            label: 'Settings',
            icon:'pi pi-fw pi-cog',
            items: [
                {
                    label: 'Account Settings',
                    routerLink:'accountSettings'
                }
            ]
          }
      ]
      /*collapsed side menu popup items*/
      this.popmenuItems = [{
        label: 'Options',
        items: [{
            label: 'Update',
            icon: 'pi pi-refresh'
        },
        {
            label: 'Delete',
            icon: 'pi pi-times'
        }
        ]},
        {
            label: 'Navigate',
            items: [{
                label: 'Angular',
                icon: 'pi pi-external-link',
                url: 'http://angular.io'
            },
            {
                label: 'Router',
                icon: 'pi pi-upload',
                routerLink: '/fileupload'
            }
        ]}
    ];

    /*collapsed side menu popup items*/
    this.profileMenu = [{
      items: [{
          label: 'User Settings'
      },
      {
          label: 'Logout'
      }
      ]}
  ];




  }

}
